import { render, staticRenderFns } from "./LayoutDashboard.vue?vue&type=template&id=1f42751e&"
import script from "./LayoutDashboard.vue?vue&type=script&lang=js&"
export * from "./LayoutDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports